import { mapObject, constant } from 'underscore';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import React, { useContext, useMemo } from 'react';

import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { I18nContext } from '@bingads-webui-react/i18n-context';

import {
  Dialog,
  DialogType,
} from '@fluentui/react';

import { EmailTagView } from './email-tag-view';
import { getEmailTagDialogStyle } from '../styles/email-tag-dialog-styles';

const EmailTagDialogUnstyled = (props) => {
  const {
    isHidden,
    onCloseEmailTagDialog,
    classes,
  } = props;
  const i18n = useContext(I18nContext);

  const dialogContentProps = useMemo(() => ({
    type: DialogType.normal,
    title: i18n.getString(_TL_('Send your tracking tag to someone else')),
    showCloseButton: true,
    subText: '',
  }), [i18n]);

  const modalProps = useMemo(() => ({
    className: classNames(classes.container, 'email-tag-dialog'),
    isBlocking: true,
    styles: {
      main: {
        minWidth: '755px !important',
        minHeight: '317px !important',
      },
    },
  }), [classes.container]);

  return (
    <Dialog
      hidden={isHidden}
      onDismiss={onCloseEmailTagDialog}
      dialogContentProps={dialogContentProps}
      modalProps={modalProps}
    >
      <EmailTagView
        showEmailTemplateLink={false}
        onSendEmail={onCloseEmailTagDialog}
      />
    </Dialog>
  );
};

EmailTagDialogUnstyled.propTypes = {
  isHidden: PropTypes.bool.isRequired,
  onCloseEmailTagDialog: PropTypes.func.isRequired,
  classes: PropTypes.shape(mapObject(
    getEmailTagDialogStyle(),
    constant(PropTypes.string.isRequired)
  )).isRequired,
};

export const EmailTagDialog = withDefaultStyles(EmailTagDialogUnstyled, getEmailTagDialogStyle);
